import * as React from "react";
import { Button, ThemeProvider } from "@material-ui/core";
import Description from "@material-ui/icons/Description";
import Typography from "@material-ui/core/Typography";
import { createTheme } from "@material-ui/core/styles";
import green from "@material-ui/core/colors/green";
import { useHistory } from "react-router-dom";
import { AddInvoiceDialog } from "../Invoices/AddInvoiceDialog";
import { UpdateInvoiceDetailsFormValues } from "../Forms/UpdateInvoiceDetailsForm";
import { useToggle } from "../../hooks/useToggle";
import { includes } from "ramda";
import { useInvoice } from "../../hooks/useInvoice";

const theme = createTheme({
  palette: {
    primary: green,
  },
});
export const GoToInvoiceButton: React.FC<{
  invoiceId?: string;
  jobId: string;
  initialValues: UpdateInvoiceDetailsFormValues;
  status: string;
  createDefaultInvoice?: boolean;
  isFlorida?: boolean;
  noSendCheckoutLinkDialog?: boolean;
  approvalStatus?: string;
  isApprovalJob?: boolean;
}> = ({
  invoiceId,
  initialValues,
  jobId,
  status,
  createDefaultInvoice,
  isFlorida,
  noSendCheckoutLinkDialog,
  approvalStatus,
  isApprovalJob,
}) => {
  const history = useHistory();
  const [open, , toggle] = useToggle();
  const { createJobInvoice } = useInvoice();

  const handleInvoice = async () => {
    if (invoiceId) {
      history.push(`/invoices/${invoiceId}`);
      return;
    }

    if (createDefaultInvoice || (isApprovalJob && approvalStatus === "Reviewed")) {
      await createJobInvoice(jobId, initialValues);
      return;
    }

    toggle();
  };
  const buttonText = invoiceId ? "View Invoice" : "Create Invoice";
  const isDisabled =
    includes(status, ["Open: En Route", "Draft", "New"]) ||
    (!invoiceId && approvalStatus !== "Reviewed" && isApprovalJob);
  return (
    <>
      <ThemeProvider theme={theme}>
        <Button className="w-1/2" variant={"contained"} color={"primary"} onClick={handleInvoice} disabled={isDisabled}>
          <div>
            <Description />
            <Typography display={"block"} variant={"caption"}>
              {buttonText}
            </Typography>
          </div>
        </Button>
      </ThemeProvider>
      <AddInvoiceDialog
        initialValues={initialValues}
        open={open}
        onClose={toggle}
        jobId={jobId}
        isFlorida={isFlorida}
        noSendCheckoutLinkDialog={noSendCheckoutLinkDialog}
      />
    </>
  );
};
